'use client';

import { useEffect, useState } from 'react';

interface FirmPhilosophyProps {
  language: 'en' | 'es';
}

const FirmPhilosophy = ({ language }: FirmPhilosophyProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    const element = document.getElementById('firm-philosophy');
    if (element) observer.observe(element);

    return () => observer.disconnect();
  }, []);

  const content = {
    en: {
      paragraph: 'We started this firm because we were tired of the same old thing. Meetings that should have been emails. Bills that made no sense. Processes designed to justify fees, not solve problems. We built Guzman Rodriguez Law to be different: fast, clear, and focused on what matters—getting you results.',
    },
    es: {
      paragraph: 'Fundamos esta firma porque estábamos cansados de lo mismo. Reuniones que debieron ser emails. Facturas que no tenían sentido. Procesos diseñados para justificar honorarios, no para resolver problemas. Construimos Guzman Rodriguez Law para ser diferentes: rápidos, claros y enfocados en lo que importa—obtener resultados para ti.',
    },
  };

  return (
    <section id="firm-philosophy" className="py-12 px-6">
      <div className="max-w-3xl mx-auto">
        <p
          className={`text-lg text-foreground leading-relaxed ${
            isVisible ? 'animate-fadeInUp' : 'opacity-0'
          }`}
        >
          {content[language].paragraph}
        </p>
      </div>
    </section>
  );
};

export default FirmPhilosophy;